import { Children, cloneElement } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

const transition = (index) => ({ delay: (index + 0.1) * 0.02, duration: 0.2, type: 'tween' });
const motionChild = {
  visible: ({ index }) => ({
    opacity: 1,
    y: 0,
    transition: transition(index),
    zIndex: 1,
  }),
  hidden: ({ index }) => ({
    opacity: 0,
    y: '10px',
    transition: transition(index),
  }),
  exit: ({ index }) => ({
    opacity: 0,
    transition: transition(index),
  }),
};

const AnimateList = ({ children, className, isVisible = true }) => {
  let elements = Children.toArray(children);
  return (
    <AnimatePresence initial={false}>
      <motion.div className={className} onAnimationComplete={() => console.log('T')}>
        {isVisible &&
          elements.map((child, index) => {
            return cloneElement(child, {
              layout: 'true',
              variants: motionChild,
              key: child.key,
              exit: 'exit',
              initial: 'hidden',
              animate: 'visible',
              custom: { index },
              // eslint-disable-next-line no-restricted-globals
              length,
            });
          })}
      </motion.div>
    </AnimatePresence>
  );
};

export default AnimateList;
